import { ProductCardType } from '@/constants'
import Link from 'next/link'
import OriginPrice from './OriginPrice'
import SalePrice from './SalePrice'

interface PriceType {
  type?: string
  classes?: string
  link?: string
  priceAtWarehouse?: boolean
  hasGift?: boolean
  originPrice: number
  finalPrice: number
  finalPriceText?: string

}

export const Price = ({
  type,
  classes,
  link = '',
  // priceAtWarehouse,
  // hasGift,
  originPrice,
  finalPrice,
  finalPriceText
}: PriceType) => {
  const percent = Math.ceil(100 - (finalPrice / originPrice) * 100)
  // Chỉ bọc thẻ Link khi có đường dẫn hợp lệ; tránh render <Link href=""> trên catch-all dynamic route [...slug] gây lỗi href="/[...slug]"
  const hasLink = Boolean(link && link.trim() !== '')

  return (
    <div className={`price-wrapper w-full mt-2 ${type ? type : ''}`}>
      <div className='flex justify-start gap-1 pb-1'>
        <OriginPrice originPrice={originPrice} classes={classes} type={type} />
        {percent > 0 && (
            <span className='discount flex font-semibold bg-[#F87171]/20 rounded-[4px] px-1 '>
              <span className='flex text-xs text-[#f00]'>
                <span className='value'>-{percent}</span>
                <span className='unit'>%</span>
              </span>
            </span>
          )}
      </div>

      <div className='sale-price flex'>
        {hasLink ? (
          <Link href={link} className='flex items-center gap-x-1 text-mainBody'>
            <SalePrice finalPrice={finalPrice} classes={classes} type={type} finalPriceText={finalPriceText} />
          </Link>
        ) : (
          <SalePrice finalPrice={finalPrice} classes={classes} type={type} finalPriceText={finalPriceText} />
        )}
      </div>
      
      {type != ProductCardType.FLASH_SALE && type === "-1" && (
        <div className='text-xs pt-0.5 text-[#000] '>
          <div className=''>*Thành viên giảm thêm đến</div>
          <div className='text-[#f00] font-bold'>526.000đ</div>
        </div>
      )}
      
    </div>
  )
}

export default Price
